import React from 'react';
import _ from 'lodash';
import { dataHooks } from './constants';
import RadioButton from '../radioButton/radioButton';
function onChange1(generatedChildren, item, itemIndex, isRadioButtonItem, value) {
  this.props.onChange(value);
}
function scopeValue2(generatedChildren, item, itemIndex, isRadioButtonItem) {
  var value = item.props.value;
  return /*#__PURE__*/React.createElement(RadioButton, {
    key: "radioButton",
    automationId: item.props.automationId,
    dataHook: item.props.dataHook,
    value: value,
    name: this.groupId,
    className: item.props.className || null,
    onChange: onChange1.bind(this, generatedChildren, item, itemIndex, isRadioButtonItem, value),
    selected: this.props.value === value,
    disabled: this.props.disabled || item.props.disabled,
    showRadioSymbol: this.props.showRadioSymbol
  }, item);
}
function scopeIsRadioButtonItem3(generatedChildren, item, itemIndex) {
  var isRadioButtonItem = this.props.radioItemPredicate(item);
  return /*#__PURE__*/React.createElement("li", {
    "data-hook": dataHooks.radioButtonItem,
    key: 'radio' + itemIndex,
    className: _({
      'radio-button-item': isRadioButtonItem,
      'selection-area': this.props.selectionArea,
      selected: item.props && this.props.value === item.props.value
    }).transform(function (res, value, key) {
      if (value) {
        res.push(key);
      }
    }, []).join(' ')
  }, isRadioButtonItem ? scopeValue2.apply(this, [generatedChildren, item, itemIndex, isRadioButtonItem]) : null, isRadioButtonItem ? null : item);
}
function repeatItem4(generatedChildren, item, itemIndex) {
  return scopeIsRadioButtonItem3.apply(this, [generatedChildren, item, itemIndex]);
}
function scopeGeneratedChildren5() {
  var generatedChildren = this.generateChildren();
  return React.createElement.apply(this, ['ul', {
    className: this.props.getClassName('control-radio-buttons-list ' + this.props.orientation),
    'data-aid': this.props.automationId,
    'data-hook': this.props.dataHook,
    'data-max-items-per-row': this.props.maxItemsPerRow
  }, _.map(generatedChildren, repeatItem4.bind(this, generatedChildren))]);
}
export default function () {
  return scopeGeneratedChildren5.apply(this, []);
}